export const generateCancellableAction = (actionBody = {}) => {
  const controller = new AbortController();

  return {
    ...actionBody,
    signal: controller.signal,
    abort: () => controller.abort(),
  };
};
